module.exports = __webpack_public_path__ + "img/beaver_add.349f5edc.png";